/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddOffice_In } from '../models/AddOffice_In';
import type { AddOffice_Out } from '../models/AddOffice_Out';
import type { GetMultipleOffices_Out } from '../models/GetMultipleOffices_Out';
import type { GetOffice_Out } from '../models/GetOffice_Out';
import type { GetOfficeTree_Out } from '../models/GetOfficeTree_Out';
import type { UpdateOffice_In } from '../models/UpdateOffice_In';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OfficesService {

    /**
     * Add Office
     * Add a new office to the system
     * @param requestBody
     * @returns AddOffice_Out Successful Response
     * @throws ApiError
     */
    public static addOffice(
        requestBody: AddOffice_In,
    ): CancelablePromise<AddOffice_Out> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/offices/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Offices
     * Get all offices for which the query office is a parent
     * @param parentOfficeId The parent office for which to get all the offices
     * @returns GetMultipleOffices_Out Successful Response
     * @throws ApiError
     */
    public static getAllOffices(
        parentOfficeId?: (string | null),
    ): CancelablePromise<GetMultipleOffices_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offices/',
            query: {
                'parent_office_id': parentOfficeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Office Tree
     * Get all offices in a tree format
     * @returns GetOfficeTree_Out Successful Response
     * @throws ApiError
     */
    public static getOfficeTree(): CancelablePromise<GetOfficeTree_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offices/tree',
        });
    }

    /**
     * Get Office
     * Get a office by its id
     * @param officeId
     * @returns GetOffice_Out Successful Response
     * @throws ApiError
     */
    public static getOffice(
        officeId: string,
    ): CancelablePromise<GetOffice_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offices/{office_id}',
            path: {
                'office_id': officeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Office
     * Update information about a specific office
     * @param officeId The id of the office to update
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateOffice(
        officeId: string,
        requestBody: UpdateOffice_In,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/offices/{office_id}',
            path: {
                'office_id': officeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Office
     * Delete a office by its id
     * @param officeId
     * @returns void
     * @throws ApiError
     */
    public static deleteOffice(
        officeId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/offices/{office_id}',
            path: {
                'office_id': officeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}